// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");

function empty(param) {
  return {
          id: undefined,
          header: "",
          dataField: DataField$ReactHooksTemplate.empty()
        };
}

function header(t) {
  return t.header;
}

function dataField(t) {
  return t.dataField;
}

function id(t) {
  return t.id;
}

function setHeader(t, header) {
  return {
          id: t.id,
          header: header,
          dataField: t.dataField
        };
}

function setdataField(t, dataField) {
  return {
          id: t.id,
          header: t.header,
          dataField: dataField
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "header",
                t.header
              ],
              tl: {
                hd: [
                  "data_field_id",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), DataField$ReactHooksTemplate.id(t.dataField))
                ],
                tl: /* [] */0
              }
            });
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          header: Json_decode.field("header", Json_decode.string, json),
          dataField: Json_decode.field("data_field", DataField$ReactHooksTemplate.decode, json)
        };
}

exports.empty = empty;
exports.header = header;
exports.dataField = dataField;
exports.id = id;
exports.setHeader = setHeader;
exports.setdataField = setdataField;
exports.encode = encode;
exports.decode = decode;
/* DataField-ReactHooksTemplate Not a pure module */
